<template>
    <div v-on:click="$hideLoginSpinner()" class="w3-modal" style="opacity: 0.75;display:block;padding-top:40px; z-index:4005;" id="loginspinner">
        <div class="flex-center-container w3-text-white">
            <font-awesome-icon size="4x" icon="spinner" spin></font-awesome-icon>
            <br>Bejelentkezés folyamatban...
        </div>    
    </div> 
</template>


<script>
export default {
  name: "LoginSpinner",
  created(){
  }
}
</script>